import React, { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableSortLabel, TableBody, Divider } from '@mui/material';
import { Partner, PartnerFilterData } from 'models';
import {
	PartnerEmptyRow,
	PartnerFilterPane,
	PartnerRow,
	TableErrorMessage,
	TableLoadingBar,
	TablePaginationFooter
} from 'components';
import { usePartners, useTableContext } from 'hooks';

export const PartnerTable = () => {
	const { partners, isFetching, error, filterFunction } = usePartners();
	const {
		visibleData,
		page,
		rowsPerPage,
		order,
		orderBy,
		handlePageChange,
		handleChangeRowsPerPage,
		filterData,
		setFilterData,
		handleSort
	} = useTableContext<Partner, PartnerFilterData>({ data: partners, filterFunction })

	return (
		<>
			<PartnerFilterPane filterData={filterData} setFilterData={setFilterData} />
			<Divider />
			<TableContainer component={Paper}>
				<Table aria-label='collapsible table'>
					<TableHead>
						<TableRow>
							<TableCell colSpan={1} />
							<TableCell colSpan={2}>
								Email
								<TableSortLabel active={orderBy === 'email'} direction={orderBy === 'email' ? order : 'asc'} onClick={() => handleSort('email')}></TableSortLabel>
							</TableCell>
							<TableCell colSpan={1}>
								First name
								<TableSortLabel active={orderBy === 'firstName'} direction={orderBy === 'firstName' ? order : 'asc'} onClick={() => handleSort('firstName')}></TableSortLabel>
							</TableCell>
							<TableCell colSpan={1}>
								Last name
								<TableSortLabel active={orderBy === 'lastName'} direction={orderBy === 'lastName' ? order : 'asc'} onClick={() => handleSort('lastName')}></TableSortLabel>
							</TableCell>
							<TableCell colSpan={1}>
								Entity type
								<TableSortLabel active={orderBy === 'entityType'} direction={orderBy === 'entityType' ? order : 'asc'} onClick={() => handleSort('entityType')}></TableSortLabel>
							</TableCell>
							<TableCell colSpan={1}>Mentor</TableCell>
							<TableCell colSpan={1}>Phone</TableCell>
							<TableCell colSpan={1}>
								Country
								<TableSortLabel active={orderBy === 'country'} direction={orderBy === 'country' ? order : 'asc'} onClick={() => handleSort('country')}></TableSortLabel>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{isFetching && <TableLoadingBar colSpan={10} />}
						{error && <TableErrorMessage error={error} colSpan={10}></TableErrorMessage>}
						{!isFetching && visibleData && (
							<>
								<PartnerEmptyRow />
								{visibleData.map((row: Partner) => (
									<PartnerRow key={row.id} row={row} />
								))}
							</>
						)}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePaginationFooter totalRows={partners?.length ?? 0} page={page} rowsPerPage={rowsPerPage} handlePageChange={handlePageChange} handleChangeRowsPerPage={handleChangeRowsPerPage} />
		</>
	);
}
